import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";

const VendorTopLogin = () => {
    return (
        <div className="vendor-top-login-wrapper">
            <div className="row">
                <div className="col-lg-7 text-center">
                    <div className="image-landing-box position-relative">
                        <div className="left-row-image-landing position-absolute"></div>
                        <div className="logo-box d-block d-lg-none">
                            <IconName name="sayman-logo" className="icon"/>
                            <h2 className="title">ورود به مرکز فروشندگان</h2>
                        </div>
                        <img className="image" src="./assets/sample-image/Group 4403.png" alt="image"/>
                        <div className="row-image-landing position-absolute"></div>
                    </div>
                </div>
                <div className="col-lg-5">
                    <div
                        className="login-landing-box d-flex justify-content-center align-items-center flex-column text-center">
                        <div className="logo-box d-none d-lg-block">
                            <IconName name="sayman-logo" className="icon"/>
                            <h2 className="title">ورود به مرکز فروشندگان</h2>
                        </div>
                        <div className="login-buttons d-block d-lg-flex align-items-center">
                            <div className="login"><Link to="/vendorLogin" className="text">ثبت نام</Link></div>
                            <div className="login-sellers-panel"><a href="#" className="text">ورود به پنل
                                فروشندگان</a></div>
                        </div>
                        <div className="sayman-text d-none d-lg-block">
                             <span className="text">
                                 با سایمان دیجیتال
                                    به کسب و کارت رونق بده!
                             </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorTopLogin;
